import { useContext, useEffect, useRef, useState } from "react";
import { TabPane, Alert } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import cloneDeep from "lodash.clonedeep";
import arrayMove from "array-move";
import * as UTILS from "../../utils/Utils";
import * as actionTypes from "../../store/Actions/actions";
import { Heading } from "./components/Heading";
import Confirm from "../Modal/Confirm";
import AddPageIcon from "../../assets/images/AddPageIcon";
import { LocalesContext } from "../../context/localesContext";
import { SelectOption } from "./components/SelectOption";
import { AddNewItem, EditItem } from "./components/Item";
import { SortableList } from "./components/Sortable";
import useClickOutside from "../../hooks/useClickOutside";
import { filterLayout } from "../../utils/layout";
import { set } from "lodash";

const Toggle = ({ checked, options, onClick }) => {
  const toggle = (e) => {
    onClick(e.target.checked ? options[1] : options[0]);
  };
  return (
    <>
      <input
        type="checkbox"
        id="toggle"
        className="toggleCheckbox"
        checked={checked}
        onChange={toggle}
        style={{ display: "none" }}
      />
      <label htmlFor="toggle" className="toggleContainer">
        {options.map((opt, i) => (
          <div key={i} className="toggle-option">
            {opt}
          </div>
        ))}
      </label>
    </>
  );
};

export const TabSettingsOptions = ({
  title,
  index,
  setIsActive,
  menuItems,
  onDuplicate,
  onRename,
}) => {
  const { layoutList, layoutLanguages } = useSelector((state) => state.present);
  const { languagesList } = useContext(LocalesContext);
  const [showLang, setshowLang] = useState(false);
  const [language, setLanguage] = useState("");
  const dispatch = useDispatch();

  const langRef = useRef(null);
  useClickOutside(langRef, () => setshowLang(false));

  useEffect(() => {
    setLanguage(layoutLanguages[index]);
  }, [layoutLanguages]);

  const openLanguageList = () => {
    setshowLang(!showLang);
  };

  const handleLanguage = (lang) => {
    setLanguage(lang);
    const newLayoutLanguages = layoutLanguages.slice();
    newLayoutLanguages[index] = lang;
    dispatch(actionTypes.set_layout_languages(newLayoutLanguages));
    setshowLang(false);
    setIsActive(false);
  };

  const deleteName = (indexItem) => {
    dispatch(actionTypes.delete_layout_list(layoutList, indexItem));
    const newLayoutLanguages = layoutLanguages.filter(
      (_, index) => index != indexItem
    );
    dispatch(actionTypes.set_layout_languages(newLayoutLanguages));
  };

  return (
    <ul>
      <li
        className="changeLanguage select-option"
        onClick={openLanguageList}
        ref={langRef}
      >
        Language
        {showLang && (
          <SelectOption
            onClick={handleLanguage}
            value={language}
            valuesList={languagesList}
            onClickOutside={() => setshowLang(false)}
          />
        )}
      </li>
      <li className="rename" onClick={() => onRename(title, index)}>
        Rename
      </li>
      <li
        className="duplicate"
        onClick={() => {
          onDuplicate(index, title);
        }}
      >
        Duplicate
      </li>
      {menuItems !== 1 && (
        <Confirm
          title="Delete Page"
          confirmMessage="Are you sure you want to delete this page?"
          element="li"
          classList="delete-icon"
          getConfirmation={(status) => {
            status && deleteName(index);
          }}
        >
          Delete
        </Confirm>
      )}
    </ul>
  );
};

const TabSettings = (props) => {
  const [addNewMenu, setAddNewMenu] = useState(false);
  const [pageLimitAlert, setPageLimitAlert] = useState(false);
  const [pageExistAlert, setPageExistAlert] = useState(false);
  const [newEditedValue, setNewEditedValue] = useState(null);
  const [clickedRenameIndex, setClickedRenameIndex] = useState(null);
  const [renaming, setRenaming] = useState(false);
  const [duplicating, setDuplicating] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const { layout, layoutList, layoutLanguages, layoutTitle } = useSelector(
    (state) => state.present
  );
  const dispatch = useDispatch();

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const _layoutList = arrayMove(layoutList, oldIndex, newIndex);
    const _layoutLanguages = arrayMove(layoutLanguages, oldIndex, newIndex);
    dispatch(
      actionTypes.reorder_layout_list({ _layoutList, _layoutLanguages })
    );
  };

  const onSaveTitle = () => {
    if (renaming) {
      updateName();
    } else {
      if (duplicating && layoutList.length < 30) {
        const pageNameExists = layoutList
          .map((layout) => layout[0])
          .find((item) => {
            return newEditedValue == item;
          });
        if (newEditedValue.length > 0 && !pageNameExists) {
          pushDuplicate();
        } else {
          setPageExistAlert(true);
          setTimeout(() => {
            setPageExistAlert(false);
          }, 3000);
        }
      } else {
        const myDiv = document.getElementsByClassName("modalContentWraper")[0];
        myDiv.scrollTop = 0;
        setPageLimitAlert(true);
      }
    }
  };
  const onAddNewPage = () => {
    if (layoutList.length < 30) {
      const pageExist = layoutList.find((layout) => {
        return layout[0].toLowerCase() == props.pageTitle.toLowerCase();
      });
      if (pageExist) {
        setErrorMessage(`Page '${props.pageTitle}' already exists`);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } else {
        props.createNewBtn();
        setAddNewMenu(false);
      }
    } else {
      const myDiv = document.getElementsByClassName("modalContentWrapper")[0];
      myDiv.scrollTop = 0;
      setPageLimitAlert(true);
    }
  };
  const changeTitle = (e) => {
    setNewEditedValue(e.target.value);
  };

  const pushDuplicate = () => {
    const _layoutList = cloneDeep(layoutList);
    const __layoutList = cloneDeep(layoutList);
    const updatedPageList = __layoutList[clickedRenameIndex];
    updatedPageList[0] = newEditedValue;
    const newToPush = UTILS.PushWithID(updatedPageList[1]);
    updatedPageList[1] = newToPush;
    _layoutList.splice(clickedRenameIndex + 1, 0, updatedPageList);
    const _layoutLanguages = layoutLanguages.slice();
    _layoutLanguages.splice(
      clickedRenameIndex + 1,
      0,
      layoutLanguages[clickedRenameIndex]
    );
    dispatch(
      actionTypes.reorder_layout_list({ _layoutList, _layoutLanguages })
    );
    setNewEditedValue(null);
    setClickedRenameIndex(null);
    setDuplicating(false);
  };

  const updateName = () => {
    const layoutListCopy = JSON.parse(JSON.stringify(layoutList));
    const pageNameExists = layoutList
      .map((layout) => layout[0])
      .find((item) => {
        (newEditedValue == item);
        (item);
        return newEditedValue == item;
      });
    if (newEditedValue.length > 0 && !pageNameExists) {
      const newList = layoutListCopy.map((item, index) => {
        if (index == clickedRenameIndex) {
          if (layoutTitle === layoutListCopy[index][0]) {
            dispatch(
              actionTypes.layout({
                titleLayout: newEditedValue,
                layout: layout,
              })
            );
            dispatch(actionTypes.set_default_page(newEditedValue));
          }
          layoutListCopy[index][0] = newEditedValue;
          return item;
        }
        return item;
      });
      dispatch(actionTypes.rename_layout_list(newList, newEditedValue));
      setNewEditedValue(null);
      setClickedRenameIndex(null);
      setRenaming(false);
    }
  };

  const onDuplicate = (index, title) => {
    setNewEditedValue("Copy of " + title);
    setClickedRenameIndex(index);
    setDuplicating(true);
  };

  const onRename = (value, index) => {
    setNewEditedValue(value);
    setClickedRenameIndex(index);
    setRenaming(true);
  };

  return (
    <>
      {pageLimitAlert && (
        <Alert
          color="danger"
          className="alert"
          fade={true}
          style={{ textAlign: "center" }}
        >
          <p>Cannot exceed 30 pages per microsite</p>
        </Alert>
      )}

      {pageExistAlert && (
        <Alert
          color="danger"
          className="alert"
          fade={true}
          style={{ textAlign: "center" }}
        >
          <p>Page name exists already</p>
        </Alert>
      )}
      <button
        onClick={() => {
          setAddNewMenu(true);
        }}
        style={{ marginTop: "10px" }}
        className="select-various-content-button"
      >
        <AddPageIcon />
        Add Page
      </button>

      <AddNewItem
        open={addNewMenu}
        title={props.pageTitle}
        onChangeTitle={props.onChangeTitle}
        placeholder="New page name"
        onSave={onAddNewPage}
        onCancel={() => {
          setAddNewMenu(false);
          setPageLimitAlert(false);
        }}
        error={errorMessage}
      />

      <EditItem
        open={newEditedValue}
        itemIndex={clickedRenameIndex}
        title={newEditedValue}
        onChangeTitle={changeTitle}
        onSave={onSaveTitle}
        onCancel={() => {
          setNewEditedValue(null);
          setRenaming(null);
          setDuplicating(null);
          setPageLimitAlert(false);
        }}
      />

      <SortableList
        items={layoutList.map((layout) => layout[0])}
        onSortEnd={onSortEnd}
        useDragHandle
      >
        <TabSettingsOptions onDuplicate={onDuplicate} onRename={onRename} />
      </SortableList>
    </>
  );
};

export const AnchorSettingsOptions = ({
  title,
  index,
  setIsActive,
  menuItems,
  onRename,
}) => {
  const { layout, anchorNavigation } = useSelector((state) => state.present);
  const dispatch = useDispatch();
  const [anchorsList, setAnchorsList] = useState([]);
  const [showAnchors, setShowAnchors] = useState(false);
  const [currentAnchor, setCurrentAnchor] = useState(
    anchorNavigation.tabs[index].link
  );
  const [errorMessage, setErrorMessage] = useState("");
  const anchorsRef = useRef(null);
  useClickOutside(anchorsRef, () => setShowAnchors(false));

  useEffect(() => {
    if (layout) {
      const anchors = filterLayout(layout, "Row").map((row) => ({
        value: row.id,
        text: row.name,
      }));
      setAnchorsList(anchors);
    }
  }, [layout]);

  const openAnchorsList = () => {
    ("anchorsList", anchorsList);
    anchorsList.length == 0
      ? setErrorMessage(
        "No anchors available, make sure to name a Row/Column element in the layout to enable this feature"
      )
      : "";
    setShowAnchors(!showAnchors);
  };

  const handleAnchor = (link) => {
    setCurrentAnchor(link);
    setIsActive(false);
    dispatch(actionTypes.rename_anchor(index, title, link));
  };

  const onDelete = (indexItem) => {
    dispatch(actionTypes.delete_anchor(indexItem));
    setIsActive(false);
  };

  return (
    <>
      {" "}
      {showAnchors &
        (errorMessage ==
          "No anchors available, make sure to name a Row/Column element in the layout to enable this feature") ? (
        <Alert
          color="danger"
          className="alert"
          fade={true}
          style={{ textAlign: "center", position: "absolute", top: '50px', width: "100px" }}
        >
          <p>{errorMessage}</p>
        </Alert>
      ) : (
        ""
      )}{" "}
      <ul>
        <li
          className="changeAnchor select-option"
          onClick={openAnchorsList}
          ref={anchorsRef}
        >
          Anchor
          {showAnchors ? (
            <SelectOption
              onClick={handleAnchor}
              value={currentAnchor}
              valuesList={anchorsList}
              onClickOutside={() => setShowAnchors(false)}
            />
          ) : (
            ""
          )}
        </li>
        <li className="rename" onClick={() => onRename(title, index)}>
          Rename
        </li>
        <li className="delete-icon" onClick={() => onDelete(index)}>
          Delete
        </li>
      </ul>
    </>
  );
};

const AnchorSettings = () => {
  const { layoutList, anchorNavigation } = useSelector(
    (state) => state.present
  );
  const { changeLocale } = useContext(LocalesContext);
  const dispatch = useDispatch();
  const pagesList = layoutList.map((v) => v[0]);
  const [selectedPage, setSelectedPage] = useState(anchorNavigation.page);
  const [addNewMenu, setAddNewMenu] = useState(false);
  const [newEditedValue, setNewEditedValue] = useState("");
  const [clickedRenameIndex, setClickedRenameIndex] = useState("");
  const [title, setTitle] = useState("");

  const [errorMessage, setErrorMessage] = useState("");

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const _anchors = arrayMove(anchorNavigation.tabs, oldIndex, newIndex);
    dispatch(actionTypes.set_anchor_list(_anchors));
  };

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };

  const onAddNewAnchor = () => {
    if (title.length) {
      if (
        !anchorNavigation.tabs.find(
          (tab) => tab.name.toLowerCase() === title.toLowerCase()
        )
      ) {
        dispatch(actionTypes.add_anchor(title, ""));
        setTitle("");
        setAddNewMenu(false);
      } else {
        setErrorMessage(`Anchor '${title}' already exists`);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }
    }
  };

  const onRename = (value, index) => {
    setNewEditedValue(value);
    setClickedRenameIndex(index);
  };

  const onSaveTitle = () => {
    if (
      !anchorNavigation.tabs.find(
        (tab) => tab.name.toLowerCase() === newEditedValue.toLowerCase()
      )
    )
      dispatch(actionTypes.rename_anchor(clickedRenameIndex, newEditedValue));
    setNewEditedValue(null);
  };

  const onPageChange = (e) => {
    const { value } = e.target;
    setSelectedPage(value);
    dispatch(actionTypes.set_default_page(value));
    let index = 0;
    const selectedLayout = layoutList.filter((item, i) => {
      if (item[0] === value) {
        index = i;
        return item;
      }
    });
    dispatch(
      actionTypes.layout({ titleLayout: value, layout: selectedLayout[0][1] })
    );
    changeLocale(index);
  };

  return (
    <div>
      <div style={{ display: "flex", width: "100%" }}>
        <button
          onClick={() => {
            setAddNewMenu(true);
          }}
          className="select-various-content-button"
        >
          <AddPageIcon />
          Add Anchor
        </button>
        {pagesList.length > 1 && (
          <div>
            <select value={selectedPage} onChange={onPageChange}>
              {pagesList.map((item, index) => {
                return (
                  <option value={item} key={index}>
                    {item}
                  </option>
                );
              })}
            </select>
            <p style={{ fontSize: "12px", textAlign: "center" }}>
              Anchors only allows navigation within the same page, please select
              which page you want to display
            </p>
          </div>
        )}
      </div>
      <AddNewItem
        open={addNewMenu}
        title={title}
        onChangeTitle={onChangeTitle}
        placeholder="New anchor name"
        onSave={onAddNewAnchor}
        onCancel={() => {
          setAddNewMenu(false);
          setTitle("");
        }}
        error={errorMessage}
      />

      <EditItem
        open={newEditedValue}
        itemIndex={clickedRenameIndex}
        title={newEditedValue}
        onChangeTitle={(e) => setNewEditedValue(e.target.value)}
        onSave={onSaveTitle}
        onCancel={() => {
          setNewEditedValue(null);
        }}
      />

      <SortableList
        items={anchorNavigation.tabs.map((tab) => tab.name)}
        onSortEnd={onSortEnd}
        useDragHandle
      >
        <AnchorSettingsOptions onRename={onRename} />
      </SortableList>
    </div>
  );
};

export const TabPages = (props) => {
  const dispatch = useDispatch();
  const { anchorNavigation } = useSelector((state) => state.present);
  const navigationStyleOptions = ["tabs", "anchors"];
  const navigationStyle =
    navigationStyleOptions[anchorNavigation.enable ? 1 : 0];

  const handleNavigationStyle = () => {
    dispatch(actionTypes.enable_anchor_navigation());
  };

  const navigationStyleContent = {
    tabs: <TabSettings {...props} />,
    anchors: <AnchorSettings />,
  };

  const handleStickyNavbar = () => {
    dispatch(actionTypes.set_sticky_anchor_navigation());
  };

  return (
    <TabPane tabId="1">
      <Heading title="Navigation Style" />
      <div
        style={{ height: "100%" }}
        className="modalContentWrapper navigationStyle"
      >
        <Toggle
          checked={anchorNavigation.enable}
          options={navigationStyleOptions}
          onClick={handleNavigationStyle}
        />
        {anchorNavigation.enable && (
          <div>
            Sticky navbar:{" "}
            <input
              type="checkbox"
              checked={anchorNavigation.sticky}
              onChange={handleStickyNavbar}
            />
          </div>
        )}
      </div>
      <Heading title="Page Management" />
      <div style={{ height: "100%" }} className="modalContentWrapper">
        {navigationStyleContent[navigationStyle]}
      </div>
    </TabPane>
  );
};
